(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    // mobile menu functionality
    (function () {
        var headerPrimaryContainerElem = document.querySelector(
            '.site-header__primary'
        );
        var currentMenuItemElem,
            navElem = document.querySelector('.mobile-nav');
        if (!navElem) return;
        // create sub-menu headlines
        navElem
            .querySelectorAll('.menu-item-has-children')
            .forEach(function (elem) {
                // check for multi-level
                if (
                    !elem.closest('.mobile-nav--multi-level') &&
                    !elem.matches('.menu-item-depth-0')
                )
                    return;
                var submenuElem = elem.querySelector('.sub-menu');
                var li = document.createElement('li');
                li.classList.add('menu-item', 'menu-item--headline');
                submenuElem.prepend(li);
                var span = document.createElement('span');
                span.classList.add('headline');
                span.textContent = elem.querySelector(
                    ':scope > .menu-link, :scope > .menu-text'
                ).textContent;
                li.append(span);
            });
        // menu-link -- set active
        document.addEventListener('click', function (e) {
            if (!e.target.closest('.mobile-nav .menu-text, .mobile-nav .menu-link'))
                return;
            var menuItemElem = e.target.closest('.menu-item');
            if (-1 == menuItemElem.className.indexOf('menu-item-has-children'))
                return;
            // check for multi-level
            if (
                !menuItemElem.closest('.mobile-nav--multi-level') &&
                -1 == menuItemElem.className.indexOf('menu-item-depth-0')
            )
                return;
            e.preventDefault();
            var menuElem = menuItemElem.parentNode.parentNode; // nav.site-mobile__nav
            menuElem
                .querySelectorAll(':scope > .menu-item')
                .forEach(function (elem) {
                    elem.classList.remove('active');
                });
            menuItemElem.classList.add('active');
            menuElem.classList.add('active');
            currentMenuItemElem = menuItemElem;

            var containerElem = e.target.closest('.mobile-nav');
            containerElem.classList.add('entered');
        });
        // prev-link -- set inactive
        function prev(menuItemElem) {
            if (!menuItemElem) return;
            var navElem = menuItemElem.closest('.mobile-nav');
            var menuElem = menuItemElem.parentNode.parentNode; // nav.site-mobile__nav
            menuItemElem.classList.remove('active');
            menuElem.classList.remove('active');
            menuItemElem = menuElem.closest('.menu-item');
            if (!menuItemElem) navElem.classList.remove('entered');
            return menuItemElem;
        }
        document.addEventListener('click', function (e) {
            if (!e.target.closest('.mobile-nav__prev')) return;
            e.preventDefault();
            currentMenuItemElem = prev(currentMenuItemElem);
        });
        // swiperight to go back/prev
        var hammertime = new Hammer(navElem.querySelector('.mobile-nav__body'));
        hammertime.on('swiperight', function (e) {
            currentMenuItemElem = prev(currentMenuItemElem);
        });
        // open-link / close-link (hamburger-trigger)
        document.addEventListener('click', function (e) {
            if (!e.target.closest('.menu-item--hamburger, .hamburger-trigger'))
                return;
            e.preventDefault();
            if (-1 == document.body.className.indexOf('mobile-nav-open')) {
                document.body.classList.add('mobile-nav-open');
            } else {
                document.body.classList.remove('mobile-nav-open');
                // reset drilldown
                navElem
                    .querySelectorAll('.site-mobile__nav, .sub-menu, .menu-item')
                    .forEach(function (elem) {
                        elem.classList.remove('active');
                    });
            }
        });
        // header primary container top-level (depth-0) links
        headerPrimaryContainerElem.addEventListener(
            'click',
            function (e) {
                // @see https://css-tricks.com/touch-devices-not-judged-size/
                // primary input mechanism system can hover over elements with ease
                if (window.matchMedia('(hover: hover)').matches) return;
                if (
                    !e.target.matches(
                        '.menu-text-inner, .menu-link-inner, .menu-text-depth-0, .menu-link-depth-0, .menu-item-depth-0'
                    )
                )
                    return;
                let menuItemElem = e.target.closest('.menu-item-depth-0');
                // check for children
                if (!menuItemElem.matches('.menu-item-has-children')) return;
                let menuElem = menuItemElem.closest('.menu');
                e.preventDefault();
                // check first, then close all
                let isOpen = menuItemElem.classList.contains('open');
                menuElem
                    .querySelectorAll('.menu-item-depth-0')
                    .forEach((elem) => elem.classList.remove('open'));
                if (!isOpen) menuItemElem.classList.add('open');
            },
            false
        );
    })();

}));
